import api from 'api';
import storage from "@/cflow/storageService";

class MinhaAssinaturaService {

    listar(dados, skip) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/minha-assinatura?skip='+skip+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }


}
export default new MinhaAssinaturaService();